const hebRegex = /[\u0590-\u05FF\uFB1D-\uFB4F]+/g;
//TODO: 1)handle English input 2)use Card for errors

export const isHebrew = (value: string) => hebRegex.test(value);
